module.exports = __webpack_public_path__ + "static/media/menu-icon.78a724f7.svg";